<template>
      <v-col>
          <v-card flat>
              <!-- <v-toolbar flat color="white">
                <v-toolbar-title>Pulpit</v-toolbar-title>
      
              </v-toolbar> -->
              <v-row>
                <v-col class="col-6 pl-3 pt-0" >
                  <v-card flat class="elevation-1 mb-5" v-if="user.permissions['desktop'] >=10">
                    <temp-courses />
                  </v-card>
                  <v-card flat class="elevation-1 mb-5">
                    <my-courses />
                  </v-card>
                  <v-card flat class="elevation-1 mb-5">
                    <kitchen-summary />
                  </v-card>
                </v-col>
                <v-col class="col-6 pl-3 pt-0">
                  <v-card flat class="elevation-1" v-if="user.permissions['desktop'] >=5">
                    <children-short-card />
                  </v-card>
                </v-col>
              </v-row>

          </v-card>
          <confirm ref="confirm"></confirm>
      </v-col>
</template>
<script>
import MyCourses from '../components/MyCourses.vue';
import confirm from '../components/Confirm';
import TempCourses from '../components/TempCourses.vue';
import ChildrenShortCard from '../components/ChildrenShortCard.vue';
import KitchenSummary from '../components/KitchenSummary';

  export default {
   components: { MyCourses,confirm, TempCourses, ChildrenShortCard,KitchenSummary },
   data: () => ({
      // componentKey:0,
      // tableOptions: {},
      // //selectedYear:0,
      // dialog: false,
      // itemEditing:false,
      // search:'',
      // itemWasDefault:false,
      // headers: [
      //   { text: '',align: 'start',sortable: false,value: 'lp',filterable:false},
      //   { text: 'Grupa', value: 'course',filterable:true,filterColumn:"courses.name" },
      //   { text: 'Nazwisko', value: 'surname',filterable:true,filterColumn:"children.surname" },
      //   { text: 'Imię', value: 'name',filterable:true,filterColumn:"children.name" },
      //   { text: 'Obecny', value: 'present',filterable:true,filterColumn:"present"},
      //   { text: 'Śniadanie', value: 'breakfast',filterable:true,filterColumn:"breakfast" },
      //   { text: 'Obiad', value: 'lunch',filterable:true,filterColumn:"lunch" },
      //   { text: 'Podwieczorek', value: 'tea',filterable:true,filterColumn:"tea" },
      //   { text: 'Godzina wejścia', value: 'entry',filterable:true,filterColumn:"presences.entry"  },
      //   { text: 'Godzina wyjścia', value: 'leave',filterable:true,filterColumn:"leave" },
      //   //{ text: 'Nieobecny', value: 'absent',filterable:true,filterColumn:"presences.present",sortable: false },
      //   //{ text: 'Uwagi', value: 'presences.note',filterable:false,filterColumn:"presences.note" },
      // ],
    }),
    validations: {

    },
    watch: {
      // tableOptions: {
      //   handler () {
      //     var currentOptions = {...this.options};
      //     const { sortBy, sortDesc } = this.tableOptions
        
      //     //zmiana sortowania
      //     if (sortBy.length === 1 && sortDesc.length === 1) {
      //       currentOptions.orderBy = _.find(this.headers,{'value':sortBy[0]}).filterColumn;
      //       currentOptions.orderDirection = sortDesc[0]?'desc':'asc';
      //       this.options = currentOptions;
      //     } 
      //   },
      //   deep: true,
      // },

    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      // options:{
      //   get () {  
      //     return this.$store.getters.getDashboardPresenceOptions;
      //   },
      //   set (value) {
      //     this.search='';
      //     this.$store.dispatch( 'setDashboardPresenceOptions', {options:value} )
      //     }
      // },
      // tableItems(){
      //   return this.$store.getters.getDashboardPresences;
      // },
      // dashboardPresencesLoadStatus(){
      //   return this.$store.getters.getDashboardPresencesLoadStatus;
      // },
      
      // computedHeaders () {
      //   // if(!this.showDeleted && this.user.permissions['dictionary'] <= 5) return this.headers.filter(h => h.value!=='status' && h.value!=='actions')
      //   // else if(this.showDeleted && this.user.permissions['dictionary'] <= 5) return this.headers.filter(h => h.value!=='actions')
      //   // else if(!this.showDeleted) return this.headers.filter(h => h.value!=='status')
      //   // else 
      //   return this.headers
      // },
     
    },
    mounted(){
     if(this.lookups.years.length>0){
        this.loadMyCourses();
        this.loadTempCourses();
        this.loadChildrenShortCard();
      }else{
        this.$store.dispatch( 'loadLookups' );
        setTimeout(() => {
          this.loadMyCourses();
          this.loadTempCourses();
          this.loadChildrenShortCard();
        }, 2000)
      }
    },
    methods: {
      loadMyCourses(){
        this.$store.dispatch( 'loadMyCourses' );
      },
      loadTempCourses(){
        if(this.user.permissions['desktop'] >=10){
          this.$store.dispatch( 'loadTempCourses' );
        }
      },
      loadChildrenShortCard(){
        if(this.user.permissions['desktop'] >=5){
          this.$store.dispatch( 'loadChildrenShortCard' );
        }
      },
    },
  }
</script>

<style scoped>

</style>